module.exports = __webpack_public_path__ + "img/b-purple@3x.8a026d83.png";